/* global Highcharts module window:true */
(function (factory) {
    if (typeof module === "object" && module.exports) {
        module.exports = factory;
    } else {
        factory(Highcharts);
    }
}(function (Highcharts) {

    Highcharts.setOptions({
        lang: {
            thousandsSep: " ",
            decimalPoint: ",",

            months: ["január", "február", "március", "április", "május", "június", "július", "augusztus", "szeptember", "október", "november", "december"],
            shortMonths: ["jan", "febr", "márc", "ápr", "máj", "jún", "júl", "aug", "szept", "okt", "nov", "dec"],
            weekdays: ["vasárnap", "hétfő", "kedd", "szerda", "csütörtök", "péntek", "szombat"],

            numericSymbols: ["k", "M", "G", "T", "P", "E"],

            loading: "Betöltés...",
            printChart: "Grafikon nyomtatása",
            downloadJPEG: "Letöltés JPEG képként",
            downloadPNG: "Letöltés PNG képként",
            downloadSVG: "Letöltés SVG képként",
            downloadPDF: "Letöltés PDF dokumentumként",
            downloadCSV: "Letöltés CSV adatként",
            viewFullscreen: "Megtekintés teljes képernyőben",
            rangeSelectorFrom: "Tól",
            rangeSelectorTo: "Ig",
            rangeSelectorZoom: "Nagyítás",
            resetZoom: "Eredeti nagyítás",
            resetZoomTitle: "Alapértékre állítja a nagyítás mértékét",
            zoomIn: "Nagyít",
            zoomOut: "Kicsinyít",
            drillUpText:"\u25c1 Vissza: {series.name}",

            embedChart: "Beágyazás",
            copyToClipboard: "Vágólapra másol",
            copiedToClipboard: "Vágólapra másolva!",
        }
    });

}));
